import qs from "qs";
import { fetchApi } from "@/utils/index";
import { errorCaptured, transUrl } from "@/utils/commonUtil.js";
// import * as ENV from '@/constants/env'

const BASE_URL = transUrl("/") + "/abs/disclosure/client/api";

export const verifyPassword = (data) => {
  const { productId, password } = data;
  const query = qs.stringify({ password }, { indices: false });
  return errorCaptured(fetchApi(`${BASE_URL}/products/${productId}?${query}`));
};
